import React, { useRef } from 'react';

import { AlertDialog, Button } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';

import { ErrorText } from 'components/checkout-errors-modal/checkout-error-cell/styled';
import { StyledHeader } from 'components/checkout-errors-modal/styled';
import { AlertDialogEventLogger } from 'components/dialog/alert-dialog-event-logger';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

type LegacyCondimentsOnlyModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const LEGACY_CONDIMENTS_ONLY_MESSAGE =
  'Sorry, you can’t check out with just condiments. Please add something else to your order to proceed.';

export const LegacyCondimentsOnlyModal = ({ isOpen, onClose }: LegacyCondimentsOnlyModalProps) => {
  const cancelRef = useRef(null);
  const router = useRouter();

  if (!isOpen) {
    return null;
  }

  return (
    <AlertDialogEventLogger
      testID="legacy-condiments-only-dialog"
      modalAppearanceEventMessage="Legacy condiments only cart"
      modalAppearanceHeader={t('invalidCart', 'Invalid cart')}
      modalAppearanceMessage={LEGACY_CONDIMENTS_ONLY_MESSAGE}
      isErrorModal
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <AlertDialog.Content>
        <AlertDialog.Header>
          <StyledHeader variant="headerTwo">{t('invalidCart', 'Invalid cart')}</StyledHeader>
        </AlertDialog.Header>
        <AlertDialog.Body>
          <ErrorText>{LEGACY_CONDIMENTS_ONLY_MESSAGE}</ErrorText>
        </AlertDialog.Body>
        <AlertDialog.Footer>
          <Button
            width="full"
            onPress={() => {
              onClose();
              router.navigate(routes.menu);
            }}
            testID="legacy-condiments-only-add-items"
          >
            {t('addItems')}
          </Button>
        </AlertDialog.Footer>
      </AlertDialog.Content>
    </AlertDialogEventLogger>
  );
};
